<app-ace-select
  #aceSelect
  [ngbTooltip]="(selectedTimezones?.length > MAX_ITEMS) && tipContent"
  placement="left"
  [items]="timezones"
  [multiSelect]="multiSelect"
  [placeholder]="placeholder"
  [compareWith]="compareFn"
  [hideSelected]="true">

  @if (!multiSelect) {
    <ng-template #labelTemplate let-item="item" let-clear="clear">
      <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
      <span class="ng-value-label" [title]="item">{{item}}</span>
    </ng-template>
  } @else {
    <ng-template #multiLabelTemplate let-items="items" let-clear="clear">
      @if (items.length <= MAX_ITEMS) {
        <div>
          @for (item of items; track item) {
            <div class="ng-value">
              <span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
              <span class="ng-value-label" [title]="item">{{item}}</span>
            </div>
          }
        </div>
      } @else {
        <div>
          <div class="ng-value">
            <span class="ng-value-label">{{ 'X Types Selected' | messageTranslate:{n: items.length} }}</span>
          </div>
        </div>
      }
    </ng-template>
  }

  <ng-template #optionTemplate let-item="item">
    <span class="ng-value-label" [title]="item">{{item}}</span>
  </ng-template>

  <ng-template #tipContent>
    <table class="cim-tooltip">
      @for (item of selectedTimezones; track item) {
        <tr>
          <td>{{ item }}</td>
        </tr>
      }
    </table>
  </ng-template>

</app-ace-select>
